export const experienceData = [
    {
        id: 1,
        company: 'Founder & Developer at Javy',
        jobtitle: 'Javy',
        startYear: '2025',
        endYear: 'Present'
    },
]